import HeadsetMicIcon from '@mui/icons-material/HeadsetMic'
import { Link } from '@mui/material'
import React from 'react'

interface SupportLinkProps {
    href: string
    t: (key: string) => string
    variant: 'flyin' | 'cleartrip'
}

const SupportLink: React.FC<SupportLinkProps> = ({ href, t, variant }) => {
    if (variant === 'cleartrip') {
        return (
            <Link
                href={href}
                underline="none"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'text.secondary',
                    '&:hover': { color: 'primary.main' },
                    transition: 'color 0.2s'
                }}
            >
                <HeadsetMicIcon sx={{ fontSize: 20 }} />
                {t('support')}
            </Link>
        )
    }

    return (
        <Link
            href={href}
            underline="none"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: { xs: 0.5, sm: 0.7 },
                color: '#1a2a3a',
                textDecoration: 'none',
                '&:hover': {
                    color: 'primary.main'
                }
            }}
        >
            <HeadsetMicIcon sx={{ fontSize: 20, color: 'inherit' }} />
            <span style={{ fontSize: 14 }}>{t('support') || 'Support'}</span>
        </Link>
    )
}

export { SupportLink }
export type { SupportLinkProps }
